import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for connections component
 */
export const connectionService = {
  getPosts,
  getConnections,
  getConnectionById,
  fetchHeaderImage,
};

function getPosts(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function getConnections(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function getConnectionById(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.posts + data.id, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function fetchHeaderImage(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.connection_headers + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
